import apiService from "../../services/apiService";

export default {
  name: "IT-Skills",
  data: () => {
    return {
      itsKillsTitle: {},
      skillsborders: []
    };
  },
  props: {
    card: Object
  },
  methods: {
    getImage(url) {
      return `https://strapi-image.herokuapp.com${url}`;
    },
    getColor(SkillColorBackground, SkillColor1, SkillColor2) {
      let style = document.createElement('style');
      style.innerHTML = `
      .HTML {
        &.box:before {
          background: linear-gradient(315deg, #ff0057, #e64a19);
        }
      }`;
      document.head.appendChild(style);
    }
  },
  async created() {
    this.itsKillsTitle = await apiService.getSkillsTitle();
    this.skillsborders = await apiService.getSkills();
  }
};